import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import tr from 'vuetify/src/locale/tr';
import { THEMES, DEFAULT_THEME, applyTheme as coreApplyTheme } from '@/plugins/theme';

Vue.use(Vuetify);

const defaultThemeConfig = THEMES[DEFAULT_THEME]?.vuetifyTheme ?? THEMES.icrapro.vuetifyTheme;

export const vuetify = new Vuetify({
    lang: {
        locales: { tr },
        current: 'tr',
    },
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        dark: false,
        disable: false,
        options: {
            customProperties: true,
        },
        themes: {
            light: { ...defaultThemeConfig },
        },
    },
    silent: process.env.NODE_ENV === 'production',
});

export function applyTheme(themeKey: string) {
    const framework = (vuetify as any).framework ?? vuetify;
    return coreApplyTheme(themeKey, framework);
}

export default vuetify;
